import Snacks from './Snacks'
export default Snacks